import React, { memo, useCallback } from "react";
import moment from "moment";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import { ClickAwayListener } from "@mui/base";

const Wrapper = styled(Box)(({ theme }) => ({
  width: "375px",
  padding: "35px 40px 74px",
  background: "#ffffff",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  borderRadius: "10px",
  position: "absolute",
  right: "-45px",
  zIndex: 10,
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    width: "292px",
    padding: "30px",
    right: "-80px",
  },
}));

const TimeList = styled(List)(({ theme }) => ({
  padding: 0,
  listStyle: "none",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "46px 55px",
  [theme.breakpoints.up("sm")]: {
    gap: "32px 37.5px",
  },
}));

const TimeListItem = styled(ListItem)(({ theme }) => ({
  display: "flex",
  padding: 0,
  alignItems: "center",
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "1.187px",
  width: "29px",
  height: "20px",
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: "1.214px",
  },
}));

const time = [
  "8:00",
  "8:30",
  "9:00",
  "9:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  // "16:00",
  // "16:30",
  // "17:00",
  // "17:30",
  // "18:00",
  // "18:30",
  // "19:00",
  // "19:30",
  // "20:00",
  // "20:30",
  // "21:00",
  // "21:30",
  // "22:00",
  // "22:30",
];

const TimePicker = memo(({ setTime, date, setTimePickerIsOpen, setTimeNotEmpty }) => {
  const handleClick = useCallback(
    (e) => {
      setTime(e.target.innerText);
      setTimePickerIsOpen(false);
    },
    [setTime, setTimePickerIsOpen]
  );

  return (
    <Wrapper>
      <TimeList>
        {time.map((el) => (
          <TimeListItem
            key={el}
            onClick={
              // moment().add(1, "days").format("DD/MM/YYYY") <
              // moment(date).format("DD/MM/YYYY")
              new Date(moment().add(1, "days")) <= new Date(moment(date))
                ? handleClick
                : moment().isBefore(moment(el, "hhmm"))
                ? handleClick
                : null 
            }
            sx={ 
              // moment().add(1, "days").format("DD/MM/YYYY") <
              // moment(date).format("DD/MM/YYYY")
              new Date(moment().add(1, "days")) <= new Date(moment(date))
                ? {
                    color: "#1a1a1a",
                    cursor: "pointer",
                  }
                : !moment().isBefore(moment(el, "hhmm"))
                ? {
                    color: "rgba(26, 26, 26, 0.2)",
                    cursor: "default",
                  }
                : {
                    color: "#1a1a1a",
                    cursor: "pointer",
                  }
            }
          >
            {el}
            <ClickAwayListener
              onClickAway={(e) => {
                if (
                  e.target.nodeName === "LI" &&
                  moment().isBefore(moment(e.target.innerText, "hhmm"))
                  
                ) {
                  setTime(e.target.innerText);
                } else if(date - moment() > 86400000 || new Date(moment().add(1, "days")) <= new Date(moment(date))) {
                  setTime(e.target.innerText);
                }
                setTimeNotEmpty(false) 
                setTimePickerIsOpen(false);
              }}
            >
              <Box></Box>
            </ClickAwayListener>
          </TimeListItem>
        ))}
      </TimeList>
    </Wrapper>
  );
});

export default TimePicker;
